export default "__VITE_ASSET__D95wVLO4__"